// extracted by mini-css-extract-plugin
module.exports = {"heading":"_id__heading__1aUoZ","content":"_id__content__3WYRP","button":"_id__button__1v5XM","sending":"_id__sending__1nHBF"};